import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldDatePicker } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const DateFieldToBlock: FieldToBlock<
  'date',
  WorkflowStepFormFieldDatePicker
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentProps: {
    placeholder: 'DD/MM/YYYY',
    size: 'sm',
  },
  componentType: 'date-picker',
  validationRules: {
    date: true,
    nullable: !field.required,
    required: field.required,
  },
});

type DateFieldValueProps = FieldValueProps<'date'>;

export const DateFieldValue: FC<DateFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
